import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f6869a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hint" }, "Пожалуйста, подождите", -1))
const _hoisted_2 = ["onClick"]

import BaseProgressBar from "@/components/BaseProgressBar.vue";
import { computed, inject, onMounted, ref } from "vue";
import { copyToClipboard } from "@/utils/сopyToClipboard";

const loadingLimit = 90;


export default /*#__PURE__*/_defineComponent({
  __name: 'EmbededPogressBar',
  setup(__props) {

const data = inject("data");

const propress = ref(1);

const startProgress = (start = 1) => {
  propress.value = Math.ceil((start / loadingLimit) * 100);

  if (start === loadingLimit) {
    return;
  }

  setTimeout(() => {
    startProgress(start + 1);
  }, 1000);
};

const copy = () => {
  copyToClipboard();
};

onMounted(() => {
  startProgress();
});

const isWaiting = computed(() => {
  return propress.value > 30;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["embede-progress-bar", { waiting: isWaiting.value }])
  }, [
    _hoisted_1,
    _createVNode(BaseProgressBar, {
      "hide-text": "",
      progress: propress.value
    }, null, 8, ["progress"]),
    _createElementVNode("button", {
      class: "copy",
      onClick: _withModifiers(copy, ["stop","prevent"])
    }, " Если нет времени ждать — нажмите сюда, чтобы скопировать ссылку и вернуться чуть позднее ", 8, _hoisted_2)
  ], 2))
}
}

})